if (window.innerWidth >= 1024){
        function popupVideoShow(url){
            var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?enablejsapi=1&autoplay=1&fs=1&playsinline=0" id="{{ "productDocumentHelpPopupIframe-" | append : section.settings.flag }}" class="youtube-player youtubeVideo productDocumentHelpPopupIframe" frameborder="0" ></iframe>';
            $("#{{ \"productDocumentHelpPopupDiv-\" | append : section.settings.flag }}").prepend(videoHtml);
            $("#{{ \"productDocumentHelpPopupShowDiv-\" | append : section.settings.flag }}").show();
        }

        $("#{{ \"productDocumentHelpPopupClose-\" | append : section.settings.flag }}").click(function() {
            $("#{{ \"productDocumentHelpPopupShowDiv-\" | append : section.settings.flag }}").hide();
            $("#{{ \"productDocumentHelpPopupIframe-\" | append : section.settings.flag }}").remove();
        });
    }

    if (window.innerWidth < 1024){
        function popupVideoShowMobile(url){
            var videoHtml = '<iframe width="100%" height="100%" src="' + url + '?enablejsapi=1&autoplay=1&fs=1&playsinline=0" id="{{ "productDocumentHelpPopupIframeMobile-" | append : section.settings.flag }}" class="youtube-player youtubeVideo productDocumentHelpPopupIframe" frameborder="0" ></iframe>';
            $("#{{ \"productDocumentHelpPopupMobileDiv-\" | append : section.settings.flag }}").prepend(videoHtml);
            $("#{{ \"productDocumentHelpPopupShowMobileDiv-\" | append : section.settings.flag }}").show();
        }

        $("#{{ \"productDocumentHelpPopupCloseMobile-\" | append : section.settings.flag }}").click(function() {
            $("#{{ \"productDocumentHelpPopupShowMobileDiv-\" | append : section.settings.flag }}").hide();
            $("#{{ \"productDocumentHelpPopupIframeMobile-\" | append : section.settings.flag }}").remove();
        });
    }
